import HeaderScrolled from '../../../helper/header-scrolled';
import ScrollTo from '../../../helper/scroll-to';
import ButtonLgClass from './button-class-lg';

const SpecPage = {
  init() {
    this._scrollToInit();
    this._headerScrolledInit();
    this._buttonClassLg();
  },


  _scrollToInit() {
    ScrollTo.init();
  },


  _headerScrolledInit() {
    HeaderScrolled.init();
  },


  _buttonClassLg() {
    ButtonLgClass.init();
  }
};

export default SpecPage;